import { createRoute } from '@tanstack/react-router';
import { pharmacyParentRoute } from 'pages/pharmacy/pharmacyParentRoute';
import { z } from 'zod';

export const pharmacyAppointmentNotesRoute = createRoute({
  getParentRoute: () => pharmacyParentRoute,
  path: '/appointment_notes',
  validateSearch: z.object({
    search: z.string().optional(),
  }),
}).lazy(() =>
  import('pages/pharmacy/AppointmentNotes/PharmacyAppointmentNotesPage').then((d) => d.Route)
);
